import moment from "moment";

function isElementInViewport(el) {
  const rect = el.getBoundingClientRect();

  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <=
      (window.innerHeight ||
        document.documentElement.clientHeight) /* or $(window).height() */ &&
    rect.right <=
      (window.innerWidth ||
        document.documentElement.clientWidth) /* or $(window).width() */
  );
}

function getDurationObject(start, end) {
  const startDate = new moment(start).hour(0);
  const endDate = new moment(end).hour(24);

  return moment.duration(endDate.diff(startDate));
}

function getDateMidpoint(date1, date2) {
  const date1Parsed = new moment(date1).toDate();
  const date2Parsed = new moment(date2).toDate();

  return new Date((date1Parsed.getTime() + date2Parsed.getTime()) / 2);
}

export default {
  isElementInViewport,
  getDurationObject,
  getDateMidpoint,
};
